import React, { useState } from 'react';
import { CheckCircle2, Copy, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const errOf = (e, f) => e?.response?.data?.detail || f;

/** Mensagem para a família com guia de primeiro acesso ao Google Classroom (senha só em memória). */
export const msgFor = (op, resp) => [
  `Olá${resp ? `, ${resp.name.split(' ')[0]}` : ''}! 😊`,
  `Seguem os dados de acesso ao Google Classroom de *${op.student_name}* (NOVO DNA):`,
  '',
  `📧 E-mail: ${op.email}`,
  `🔑 Senha temporária: ${op.senha_temporaria}`,
  '',
  '*Primeiro acesso — passo a passo*',
  '1️⃣ No computador, abra classroom.google.com. No celular/tablet, instale o app *Google Classroom* (Play Store ou App Store).',
  '2️⃣ Toque em *Fazer login* (se já houver outra conta Google no aparelho, escolha *Usar outra conta*).',
  '3️⃣ Digite o e-mail acima e toque em *Avançar*.',
  '4️⃣ Digite a senha temporária exatamente como está (maiúsculas, minúsculas e símbolos fazem diferença).',
  '5️⃣ O Google pedirá uma *nova senha pessoal*: crie uma com pelo menos 8 caracteres e anote em local seguro.',
  '6️⃣ Aceite os termos, escolha a função *Sou aluno* (se perguntado) e pronto: as turmas aparecerão na tela inicial.',
  '',
  '💡 Dicas: a senha temporária só funciona no primeiro acesso. Se esquecer a nova senha, fale com a secretaria.',
  '🔒 Por segurança, não compartilhe estes dados.',
  '',
  'Secretaria NOVO DNA',
].join('\n');

/** Seleção do responsável + Copiar mensagem / Abrir WhatsApp / Confirmar que enviei (tudo manual e registrado). */
export function EnvioActions({ studentId, op, responsaveis, onLogged, testid = 'google-acesso' }) {
  const [rid, setRid] = useState(responsaveis.find((r) => r.has_phone)?.responsible_id || responsaveis[0]?.responsible_id || '');
  const resp = responsaveis.find((r) => r.responsible_id === rid);
  const ev = async (tipo) => { const { data } = await api.post(`/google-acessos/aluno/${studentId}/evento`, { tipo, responsible_id: rid, operation_id: op.operation_id }); onLogged?.(tipo); return data; };
  const copy = async () => {
    try { await navigator.clipboard.writeText(msgFor(op, resp)); await ev('mensagem_copiada'); toast.success('Mensagem copiada. Cole no WhatsApp e envie manualmente.'); }
    catch (e) { toast.error(errOf(e, 'Não foi possível copiar.')); }
  };
  const open = async () => { try { const r = await ev('whatsapp_aberto'); window.open(r.whatsapp_url, '_blank', 'noopener,noreferrer'); } catch (e) { toast.error(errOf(e, 'Falha ao abrir o WhatsApp.')); } };
  const confirm = async () => { try { await ev('envio_confirmado'); toast.success('Envio registrado como confirmado pelo operador.'); } catch (e) { toast.error(errOf(e, 'Falha.')); } };
  return (
    <div className="space-y-2">
      <Select value={rid} onValueChange={setRid}><SelectTrigger data-testid={`${testid}-responsavel`}><SelectValue placeholder="Selecione o responsável" /></SelectTrigger>
        <SelectContent>{responsaveis.map((r) => <SelectItem key={r.responsible_id} value={r.responsible_id}>{r.name} · {r.relation} · {r.phone_masked || 'sem telefone'}</SelectItem>)}</SelectContent></Select>
      {!responsaveis.length && <p className="text-[12px] text-amber-700">Nenhum responsável vinculado no cadastro do aluno.</p>}
      <div className="grid gap-2 sm:grid-cols-3">
        <Button size="sm" variant="outline" onClick={copy} disabled={!rid} data-testid={`${testid}-copiar`}><Copy className="h-4 w-4" /> Copiar mensagem</Button>
        <Button size="sm" variant="outline" onClick={open} disabled={!resp?.has_phone} className="border-emerald-300 text-emerald-700" data-testid={`${testid}-whatsapp`}><MessageCircle className="h-4 w-4" /> Abrir WhatsApp</Button>
        <Button size="sm" onClick={confirm} disabled={!rid} data-testid={`${testid}-confirmar-envio`}><CheckCircle2 className="h-4 w-4" /> Confirmar que enviei</Button>
      </div>
    </div>
  );
}
